module.exports = __webpack_public_path__ + "img/3-13-1.8fd4dfb3.png";